import { render, staticRenderFns } from "./ClosedTable.vue?vue&type=template&id=31c2c4df"
import script from "./ClosedTable.vue?vue&type=script&lang=js"
export * from "./ClosedTable.vue?vue&type=script&lang=js"
import style0 from "./ClosedTable.vue?vue&type=style&index=0&id=31c2c4df&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports